export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";